import React from "react";

import { colors } from "@zapalacorp/tokens";
import { useTranslation } from "react-i18next";
import { FiPlus } from "react-icons/fi";

import { Button } from "../../../../../../../../components/Form";
import { Color } from "../../../../../../../../components/Form/Button";
import { Body, Wrapper, EmptyTitle, EmptySubTitle, EmptyDivButtons } from "./styles";

const EMPTY_STATE_IMG = require("Assets/img/title-background.svg");

interface EmptyStateProps {
  onAddOrder?: () => void;
  onAddQuickOrder?: () => void;
  title?: string;
  buttonLabel?: string;
  description?: string;
}
export function EmptySection(props: EmptyStateProps) {
  const { onAddOrder, onAddQuickOrder } = props;
  const { t: translate } = useTranslation();

  return (
    <Wrapper>
      <img src={EMPTY_STATE_IMG} alt="empty-state" height={200} width={250} />
      <Body>
        <EmptyTitle>{props?.title || translate("noLinkNotYet")}</EmptyTitle>
        <EmptySubTitle>
          {props?.description || translate("startByAddingAnOrderToShipment")}
        </EmptySubTitle>
        <EmptyDivButtons>
          {onAddOrder && (
            <Button onClick={onAddOrder} startIcon={<FiPlus />} customColor={Color.SECONDARY_DARK}>
              {props?.buttonLabel || translate("addOrders")}
            </Button>
          )}
          {onAddQuickOrder && (
            <Button
              onClick={onAddQuickOrder}
              startIcon={<FiPlus />}
              customColor={Color.BRAND_OUTLINED}
            >
              {props?.buttonLabel || translate("quickOrder")}
            </Button>
          )}
        </EmptyDivButtons>
      </Body>
    </Wrapper>
  );
}
